import React, { Component } from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Geocode from "react-geocode";
import Autocomplete from "react-google-autocomplete";
/* import { GoogleMapsAPI } from "../client-config"; */
import { Col, Badge, Card, Row } from "react-bootstrap";
/* Geocode.setApiKey(GoogleMapsAPI); */
Geocode.enableDebug();

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      city: "",
      area: "",
      state: "",
      mapPosition: {
        lat: this.props.center.lat,
        lng: this.props.center.lng,
      },
      markerPosition: {
        lat: this.props.center.lat,
        lng: this.props.center.lng,
      },
      test: "AIzaSyAoVzr50f6wuOdLYUhUTvV7plTBWe6SxDs",
    };
  }
  /**
   * Get the current address from the default map position and set those values in the state
   */
  componentDidMount() {
    Geocode.fromLatLng(
      this.state.mapPosition.lat,
      this.state.mapPosition.lng
    ).then(
      (response) => {
        const address = response.results[0].formatted_address,
          addressArray = response.results[0].address_components,
          city = this.getCity(addressArray),
          area = this.getArea(addressArray),
          state = this.getState(addressArray);
        console.log("city", city, area, state);
        this.setState({
          address: address ? address : "",
          area: area ? area : "",
          city: city ? city : "",
          state: state ? state : "",
        });
        this.props.reRender(this.state);
      },
      (error) => {
        console.error(error);
      }
    );
  }
  /**
   * Component should only update ( meaning re-render ), when the user selects the address, or drags the pin
   *
   * @param nextProps
   * @param nextState
   * @return {boolean}
   */
  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.state.markerPosition.lat !== this.props.center.lat ||
      this.state.address !== nextState.address ||
      this.state.city !== nextState.city ||
      this.state.area !== nextState.area ||
      this.state.state !== nextState.state
    ) {
      return true;
    } else if (this.props.center.lat === nextProps.center.lat) {
      return false;
    }
  }
  /**
   * Get the city and set the city input value to the one selected
   *
   * @param addressArray
   * @return {string}
   */
  getCity = (addressArray) => {
    let city = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (
        addressArray[i].types[0] &&
        "administrative_area_level_2" === addressArray[i].types[0]
      ) {
        city = addressArray[i].long_name;
        return city;
      }
    }
  };
  /**
   * Get the area and set the area input value to the one selected
   *
   * @param addressArray
   * @return {string}
   */
  getArea = (addressArray) => {
    let area = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0]) {
        for (let j = 0; j < addressArray[i].types.length; j++) {
          if (
            "sublocality_level_1" === addressArray[i].types[j] ||
            "locality" === addressArray[i].types[j]
          ) {
            area = addressArray[i].long_name;
            return area;
          }
        }
      }
    }
  };
  /**
   * Get the address and set the address input value to the one selected
   *
   * @param addressArray
   * @return {string}
   */
  getState = (addressArray) => {
    let state = "";
    for (let i = 0; i < addressArray.length; i++) {
      for (let i = 0; i < addressArray.length; i++) {
        if (
          addressArray[i].types[0] &&
          "administrative_area_level_1" === addressArray[i].types[0]
        ) {
          state = addressArray[i].long_name;
          return state;
        }
      }
    }
  };
  /**
   * And function for city,state and address input
   * @param event
   */
  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  /**
   * This Event triggers when the marker window is closed
   *
   * @param event
   */
  onInfoWindowClose = (event) => { };

  /**
   * When the marker is dragged you get the lat and long using the functions available from event object.
   * Use geocode to get the address, city, area and state from the lat and lng positions.
   * And then set those values in the state.
   *
   * @param event
   */
  onMarkerDragEnd = (event) => {
    let newLat = event.latLng.lat(),
      newLng = event.latLng.lng();

    Geocode.fromLatLng(newLat, newLng).then(
      (response) => {
        const address = response.results[0].formatted_address,
          addressArray = response.results[0].address_components,
          city = this.getCity(addressArray),
          area = this.getArea(addressArray),
          state = this.getState(addressArray);
        this.setState({
          address: address ? address : "",
          area: area ? area : "",
          city: city ? city : "",
          state: state ? state : "",
          markerPosition: {
            lat: newLat,
            lng: newLng,
          },
          mapPosition: {
            lat: newLat,
            lng: newLng,
          },
        });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  /**
   * When the user types an address in the search box
   * @param place
   */
  onPlaceSelected = (place) => {
    console.log("plc", place);
    const address = place.formatted_address,
      addressArray = place.address_components,
      city = this.getCity(addressArray),
      area = this.getArea(addressArray),
      state = this.getState(addressArray),
      latValue = place.geometry.location.lat(),
      lngValue = place.geometry.location.lng();
    // Set these values in the state.
    this.setState({
      address: address ? address : "",
      area: area ? area : "",
      city: city ? city : "",
      state: state ? state : "",
      markerPosition: {
        lat: latValue,
        lng: lngValue,
      },
      mapPosition: {
        lat: latValue,
        lng: lngValue,
      },
    });
  };

  render() {
    const AsyncMap = withScriptjs(
      withGoogleMap((props) => (
        <GoogleMap
          google={this.props.google}
          defaultZoom={this.props.zoom}
        // defaultCenter={{ lat: this.state.mapPosition.lat, lng: this.state.mapPosition.lng }}
        >
          {/* InfoWindow on top of marker */}
          <InfoWindow
            onClose={this.onInfoWindowClose}
            position={{ lat: 13.018916, lng: 80.207064 }}
          >
            <div>
              <span style={{ padding: 0, margin: 0 }}>
                {this.state.address}
              </span>
            </div>
          </InfoWindow>
          {/*Marker*/}
          <Marker
            google={this.props.google}
            name={"Dolores park"}
            draggable={true}
            onDragEnd={this.onMarkerDragEnd}
            position={{ lat: 13.018916, lng: 80.207064 }}
          />

          <Marker />
          {/* For Auto complete Search Box */}
          <Autocomplete
            style={{
              width: "100%",
              height: "40px",
              paddingLeft: "16px",
              marginTop: "2px",
              marginBottom: "500px",
            }}
            onPlaceSelected={this.onPlaceSelected}
            types={["(regions)"]}
          />
        </GoogleMap>
      ))
    );
    let map;
    if (this.props.center.lat !== undefined) {
      map = (
        <div>
          <Col xl="12">
            <Card>
              <Card.Header className="text-white bg-secondary">
                <Card.Title style={{ color: "white" }}>Location</Card.Title>
              </Card.Header>
              <Card.Body className="mb-0 bg-green-light">
                <Card.Text style={{ fontSize: "medium" }}>
                  <div className="row">
                    <div className="col-md-8">
                      <AsyncMap
                        // googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${this.state.test}&libraries=places`}
                        // googleMapURL={"https://maps.googleapis.com/maps/api/js?key=AIzaSyAoVzr50f6wuOdLYUhUTvV7plTBWe6SxDs&libraries=geometry,drawing,places"}
                        googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
                        loadingElement={<div style={{ height: `100%` }} />}
                        containerElement={
                          <div style={{ height: this.props.height }} />
                        }
                        mapElement={<div style={{ height: `100%` }} />}
                      />
                    </div>

                    <div class="col-md-4 col-sm-6 col-xl-4 ">


                      <div className="form-group">
                        <label
                          as="d"
                          variant="badge badge-rounded badge-danger"
                        >
                          {" "}
                          State
                        </label>

                        <br />
                        <input
                          type="text"
                          name="state"
                          className="form-control"
                          onChange={this.onChange}
                          readOnly="readOnly"
                          value={this.state.state}
                          style={{ backgroundColor:"whitesmoke" }}
                        />
                      </div>

                      <div className="form-group">
                        <label
                          as="a"
                          variant="badge badge-rounded badge-danger"
                        >                          City
                        </label>
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          onChange={this.onChange}
                          readOnly="readOnly"
                          value={this.state.city}
                          style={{ backgroundColor:"whitesmoke" }}
                        />
                      </div>

                      <div className="form-group">
                        <label
                          as="d"
                          variant="badge badge-rounded badge-danger"
                        >
                          {" "}
                          Area
                        </label>

                        <br />
                        <input
                          type="text"
                          maxLength="30"
                          name="area"
                          className="form-control"
                          onChange={this.onChange}
                          readOnly="readOnly"
                          value={this.state.area}
                          style={{ backgroundColor:"whitesmoke" }}
                        />
                      </div>



                      <div className="form-group">
                        <label
                          as="d"
                          variant="badge badge-rounded badge-danger"
                        >
                          Address
                        </label>
                        <br />
                        <input
                          type="textarea"
                          name="address"
                          maxLength="30"
                          className="form-control"
                          onChange={this.onChange}
                          readOnly="readOnly"
                          value={this.state.address}
                          style={{ backgroundColor:"whitesmoke" }}
                        />
                      </div>
                    </div>
                  </div>
                </Card.Text>{" "}
                <br /> <br />
              </Card.Body>
             
            </Card>
          </Col>
        </div>
      );
    } else {
      map = <div style={{ height: this.props.height }} />;
    }
    return map;
  }
}
export default Map;
